import { render } from "./SellerAfterSales.vue?vue&type=template&id=541443d7&scoped=true"
import script from "./SellerAfterSales.vue?vue&type=script&lang=js"
export * from "./SellerAfterSales.vue?vue&type=script&lang=js"

import "./SellerAfterSales.vue?vue&type=style&index=0&id=541443d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541443d7"]])

export default __exports__